<div [ngClass]="[align ?? '']" [storyblokRichText]="content"></div>
<table *ngIf="display_table && table && table?.thead" class="mt-3 table">
  <thead>
    <tr>
      <th *ngFor="let th of table.thead">{{ th.value }}</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let tr of table.tbody">
      <td *ngFor="let td of tr.body">{{ td.value }}</td>
    </tr>
  </tbody>
</table>
